import { Box, Button, Typography } from '@mui/material';

interface PropsData {
  onCreateClick: () => void;
  buttonName: string;
  message: string;
}

const NoDataFound = ({ onCreateClick, buttonName, message }: PropsData) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
    }}
  >
    <Typography sx={{ fontSize: '1.1rem', marginBottom: '16px', fontWeight: 500 }}>{message || 'No Data Found'}</Typography>
    <Button variant="outlined" color="primary" size="medium" sx={{ fontSize: '0.875rem', padding: '6px 20px', borderRadius: '20px' }} onClick={onCreateClick}>
      {buttonName || 'Click'}
    </Button>
  </Box>
);

export default NoDataFound;
